import { reatomAsync } from '@reatom/async';
import { BACKEND_API } from '@trwl/backend.api';

export const logoutAction = reatomAsync(
  () => BACKEND_API.AuthApi.logout(),
  'logoutAction',
);
